import Cookies from 'universal-cookie/es6';
import { useHistory } from "react-router-dom";

/* =============================================================================
Remuner software (c)
Vibe Consulting.
Componente : MenuItems3
Description : Componente que contiene la información de los botones de la barra de navegación de la aplicación
Date Autor Modification
================================================================================
23/10/2021 Cristian Andres Pizo Mina Creación – Se defienen los botones de la barra de navegación.
13/10/2021 Cristian Andres Pizo Mina -  Se agrego /Overtime
================================================================================ */
export default function MenuItems4() {
    let history = useHistory();
    const cookies = new Cookies();
    const items = [
        {
            label: 'Programación',
            path: "/Scheduling",
            index: 0,
            icon: (localStorage.getItem('tracking') === 'N') && "pi pi-lock",
        },
        {
            label: 'Marcación',
            path: "/Marking",
            index: 1,
            icon: (localStorage.getItem('tracking') === 'N') && "pi pi-lock",
        },
        {
            label: 'Novedades ocasionales marcación',
            path: "/OccasionalMarking",
            index: 2,
            icon: (localStorage.getItem('tracking') === 'N') && "pi pi-lock",
        },
        {
            label: 'Novedades ocasionales marcación histórico',
            path: "/HistoricOccasionalMarking",
            index: 3,
            icon: (localStorage.getItem('tracking') === 'N') && "pi pi-lock",
        },
    ];
    return items
}